import { proxy, ref } from 'valtio';

import { type EntityId } from '@canvas/model/ecs';
import { TileMap } from '@canvas/tiling';
import { TileSearcher } from '@canvas/tiling/searcher';

export const currentTiler = proxy({
  searcher: ref(new TileSearcher<EntityId>(new TileMap(2048))),
});
